export default {
  page_title: 'Consommations',
  page_description: 'Suivre l\'utilisation des ressources consommables',
  editTitle: 'Modifier la Consommation',
  editSubtitle: 'Mettre à jour les informations de la consommation',
  consume_resource: 'Consommer une Ressource',
  resource: 'Ressource',
  user: 'Utilisateur',
  quantity_consumed: 'Quantité Consommée',
  consumed_date: 'Date de Consommation',
  notes: 'Notes',
  notes_placeholder: 'Entrez des notes sur cette consommation...',
  quantity_to_consume: 'Quantité à Consommer',
  available_quantity: 'Quantité Disponible',
  consume: 'Consommer',
  consumed_successfully: 'Ressource consommée avec succès',
  invalid_quantity: 'La quantité doit être supérieure à 0',
  insufficient_quantity: 'Quantité insuffisante disponible',
  unknown_resource: 'Ressource Inconnue',
  unknown_user: 'Utilisateur Inconnu',
  units: 'unités',
  admin: {
    createTitle: 'Créer une Consommation',
    editTitle: 'Modifier la Consommation',
    deleteTitle: 'Supprimer la Consommation',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette consommation',
    createSuccess: 'Consommation créée avec succès',
    updateSuccess: 'Consommation modifiée avec succès',
    deleteSuccess: 'Consommation supprimée avec succès',
    createError: 'Échec de la création de la consommation',
    updateError: 'Échec de la modification de la consommation',
    deleteError: 'Échec de la suppression de la consommation'
  }
};
